"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeCount = normalizeCount;

function normalizeCount(count) {
  if (!count) return 0;
  if (count < 0) return 0;
  if (count > 99) return '99+';
  return count;
}
//# sourceMappingURL=favicon.js.map